import { Role } from '@/graphql/generated';

export const defaultFilters = () => ({
  searchString: '',
  filterRole: null as Role | null,
});

export type UsersFilters = ReturnType<typeof defaultFilters>;

export enum LocalRole {
  Owner = 'OWNER',
}

export type RolesType = Role | LocalRole;

export const Roles = { ...Role, ...LocalRole };

export const USER_ROLE_MAP = {
  [Roles.Accountant]: 'Бухгалтер',
  [Roles.Administrator]: 'Администратор',
  [Roles.BookingManager]: 'Менеджер бронирований ',
  [Roles.RevenueManager]: 'Revenue-менеджер',
  [Roles.Support]: 'Служба поддержки',
  [Roles.Owner]: 'Владелец',
} as const;

export const USER_ROLE_SELECT_ITEMS = [
  { title: USER_ROLE_MAP[Roles.Administrator], value: Roles.Administrator },
  { title: USER_ROLE_MAP[Roles.BookingManager], value: Roles.BookingManager },
  { title: USER_ROLE_MAP[Roles.RevenueManager], value: Roles.RevenueManager },
  { title: USER_ROLE_MAP[Roles.Accountant], value: Roles.Accountant },
  { title: USER_ROLE_MAP[Roles.Support], value: Roles.Support, hidden: true },
  { title: USER_ROLE_MAP[Roles.Owner], value: Roles.Owner, hidden: true },
];
